import React, { useEffect } from 'react';

import {
  WithPopover,
  Flexbox,
  FontAwesomeIcon,
  Text,
} from '@schoolinks/ui-components';

import { isEmpty, isNil } from 'lodash';

import { useDispatch } from 'react-redux';

import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown';

import { tryRefreshingToken } from 'actions/user';

import Api from 'core/api';
import useMutation from 'hooks/useMutation';
import useRedirect from 'hooks/useRedirect';
import useUserRedux from 'hooks/useUserRedux';
import { ensureObject } from 'utils/objects';

import {
  DASHBOARD_MODES,
  ALLOWED_NAVIGATE_ROUTES,
} from 'modules/AccountSetupV2/widgets/K12DashboardSwitcher/constants';
import SwitcherRedirectMap from 'modules/AccountSetupV2/widgets/K12DashboardSwitcher/switcherRedirectMap';
import {
  resetFilters,
  setHasFetchedFilters,
} from 'modules/StudentScopeFilter/actions';

import s from './K12DashboardSwitcher.module.css';

const K12DashboardSwitcher = () => {
  const dispatch = useDispatch();
  const { redirect } = useRedirect();
  const {
    data: { currentUserMode, userModes },
  } = useUserRedux();

  const { mutateAsync: updateCurrentUserMode } = useMutation({
    apiFunc: Api.slUsers.updateCurrentUserMode,
    onSuccess: async ({ data }) => {
      const { currentUserMode: newMode } = ensureObject(data);
      await dispatch(tryRefreshingToken());
      window.location.href = DASHBOARD_MODES[newMode]?.route;
    },
  });

  useEffect(() => {
    const { pathname } = window.location;
    const allowNavigate = ALLOWED_NAVIGATE_ROUTES.includes(pathname);

    if (
      allowNavigate &&
      currentUserMode &&
      pathname !== DASHBOARD_MODES[currentUserMode].route
    ) {
      SwitcherRedirectMap[currentUserMode]({ redirect });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUserMode]);

  if (isNil(userModes) || isEmpty(userModes) || userModes?.length <= 1) {
    return null;
  }

  return (
    <WithPopover
      messagePlacement="bottom"
      tooltipProps={{
        title: 'Switch your currently active dashboard on SchooLinks',
      }}
      anchorButtonClass={s.anchorButton}
      anchorContent={() => (
        <Flexbox gap={1} alignItems="center" className={s.anchorContainer}>
          <Text variant='bodySm600'>
            {DASHBOARD_MODES[currentUserMode].title}
          </Text>
          <FontAwesomeIcon icon={faAngleDown} />
        </Flexbox>
      )}
      menuProps={{
        selectedId: DASHBOARD_MODES[currentUserMode].title,
        items: userModes.map(opt => ({
          textContent: DASHBOARD_MODES[opt.mode].title,
          id: DASHBOARD_MODES[opt.mode].title,
          onClick: () => {
            dispatch(resetFilters());
            dispatch(setHasFetchedFilters(false));
            updateCurrentUserMode({
              payload: { currentUserMode: opt.mode },
            });
          },
        })),
      }}
    />
  );
};

export default K12DashboardSwitcher;
